import Vue from 'vue';
import Auth from '../directives/AuthRequired';

Vue.mixin(Auth); 